import React, { useEffect, useState } from "react";
import { Search, XCircle } from "react-feather";
import { useAsyncDebounce, HeaderGroup } from "react-table";

interface TextFilterProps<T extends object> {
  column: HeaderGroup<T>;
}

const TextFilter = <T extends object>({ column }: TextFilterProps<T>) => {
  const { filterValue, setFilter } = column;
  const [value, setValue] = useState(filterValue);
  const debouncedSetFilter = useAsyncDebounce(setFilter, 250);
  useEffect(() => {
    setValue(filterValue);
  }, [filterValue]);

  const resetValue = () => {
    debouncedSetFilter(null);
  };
  return (
    <div className="search">
      <span className="search-icon">
        <Search />
      </span>
      <input
        autoFocus
        className="form-control"
        placeholder="Search"
        value={value || ""}
        onChange={(e) => {
          const value = e.target.value;
          setValue(value);
          debouncedSetFilter(value);
        }}
      />
      <span className="close-icon">
        <XCircle
          onClick={(e) => {
            resetValue();
          }}
        />
      </span>
    </div>
  );
};

export default TextFilter;
